import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import * as endpoints from "../networkUtility/endpoints";

import * as localStorageActiontype from "../LocalStorage/ActionTypes";
import { getLocalStorage } from "../LocalStorage/GetLocalStorage";

import { toggleNotificationVisibility } from "./networkNotification";
import { NotificationType } from "../Utility/InterFacesAndEnum";
import { toggleLoader } from "./loader";
import { handle401Status } from "../Utility/Utility";

interface UploaderState {
    images: string[] | [];
    imageNames: string[] | [];
    thumbnail: string[] | [];
    thumbnailName: string[] | [];
}

interface ImageObj {
    documentName: string;
    fileDownloadUri: string;
    fileId: string;
    fileName: string;
    fileSize: number;
    fileType: string;
}

interface SetImages {
    data: string[] | [];
    names: string[] | [];
}
interface setThumbnail {
    data: string[] | [];
    names: string[] | [];
}

const imageUploaderInitialState: UploaderState = {
    images: [],
    imageNames: [],
    thumbnail: [],
    thumbnailName: [],
};

export const uploadImage = createAsyncThunk(
    "upload image",
    async (payload: any, { dispatch }) => {
        dispatch(
            toggleLoader({
                isLoading: true,
            })
        );
        await fetch(endpoints.uploadImage, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${getLocalStorage(
                    localStorageActiontype.GET_ACCESS_TOKEN
                )}`,
            },
            body: payload,
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                let image: ImageObj = response;
                let responseArray: string[] = [];
                let names: string[] = [];
                let imageString = image.fileDownloadUri;
                let name = image.fileName;
                responseArray.push(imageString);
                names.push(name);

                dispatch(
                    setImages({
                        data: responseArray,
                        names: names,
                    })
                );
            })
            .catch((error) => {
                console.log(error);
                dispatch(
                    toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.error,
                        message: "something went wrong!!!!",
                    })
                );
            })
            .finally(() => {
                dispatch(
                    toggleLoader({
                        isLoading: false,
                    })
                );
            });
    }
);

export const uploadThumbnail = createAsyncThunk(
    "upload image",
    async (payload: any, { dispatch }) => {
        dispatch(
            toggleLoader({
                isLoading: true,
            })
        );
        await fetch(endpoints.uploadImage, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${getLocalStorage(
                    localStorageActiontype.GET_ACCESS_TOKEN
                )}`,
            },
            body: payload,
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                let image: ImageObj = response;
                let responseArray: string[] = [];
                let names: string[] = [];
                let imageString = image.fileDownloadUri;
                let name = image.fileName;
                responseArray.push(imageString);
                names.push(name);

                dispatch(
                    setThumbnail({
                        data: responseArray,
                        names: names,
                    })
                );
            })
            .catch((error) => {
                console.log(error);
                dispatch(
                    toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.error,
                        message: "something went wrong!!!!",
                    })
                );
            })
            .finally(() => {
                dispatch(
                    toggleLoader({
                        isLoading: false,
                    })
                );
            });
    }
);

export const uploadMultipleImages = createAsyncThunk(
    "upload images",
    async (payload: any, { dispatch }) => {
        console.log(payload);
        await fetch(endpoints.uploadImageArray, {
            method: "POST",
            body: payload,
            headers: {
                Authorization: `Bearer ${getLocalStorage(
                    localStorageActiontype.GET_ACCESS_TOKEN
                )}`,
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                console.log(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }
);

const ImageUploaderSlice = createSlice({
    name: "Image uploader",
    initialState: imageUploaderInitialState,
    reducers: {
        setImages: (state, action: PayloadAction<SetImages>) => {
            let updatedArray: any = [];
            if (state.images !== null && state.images.length > 0) {
                updatedArray = [...state.images].concat(action.payload.data);
            }

            if (state.images === null || state.images.length === 0) {
                updatedArray = action.payload.data;
            }

            return {
                ...state,
                images: updatedArray,
                imageNames: [...state.imageNames, ...action.payload?.names],
            };
        },
        setThumbnail: (state, action: PayloadAction<setThumbnail>) => {
            let updatedArray: any = [];
            if (state.thumbnail !== null && state.thumbnail.length > 0) {
                updatedArray = [...state.thumbnail].concat(action.payload.data);
            }

            if (state.thumbnail === null || state.thumbnail.length === 0) {
                updatedArray = action.payload.data;
            }

            return {
                ...state,
                thumbnail: updatedArray,
                thumbnailName: [...state.thumbnail, ...action.payload.names],
            };
        },
        setUpdateImgDetails: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                images: action.payload.images,
                imageNames: action.payload.imageNames,
            };
        },
        deleteImage: (state, action: PayloadAction<{ imgUrl: string }>) => {
            let filteredImages: any = [];
            let filteredImagesNames: any = [];

            if (state.images !== null && state.images.length > 0) {
                filteredImages = state.images.filter((img) => {
                    return img !== action.payload.imgUrl;
                });
            }

            const imageUrl = action.payload.imgUrl;
            const parts = imageUrl.split("/");
            const imageName = parts[parts.length - 1];

            if (state.imageNames !== null && state.imageNames.length > 0) {
                filteredImagesNames = state.imageNames.filter((img) => {
                    return img !== imageName;
                });
            }
            return {
                ...state,
                images: filteredImages,
                imageNames: filteredImagesNames,
            };
        },
        deleteThumbnail: (state, action: PayloadAction<{ imgUrl: string }>) => {
            let filteredImages: any = [];
            let filteredThumbnailNames: any = [];

            if (state.thumbnail !== null && state.thumbnail.length > 0) {
                filteredImages = state.thumbnail.filter((img) => {
                    return img !== action.payload.imgUrl;
                });
            }

            const imageUrl = action.payload.imgUrl;
            const parts = imageUrl.split("/");
            const imageName = parts[parts.length - 1];

            if (state.imageNames !== null && state.imageNames.length > 0) {
                filteredThumbnailNames = state.imageNames.filter((img) => {
                    return img !== imageName;
                });
            }
            return {
                ...state,
                thumbnail: filteredImages,
                thumbnailName: filteredThumbnailNames
            };
        },
        resetImages: (state) => {
            return {
                ...state,
                images: [],
                imageNames: [],
            };
        },
        resetThumbnail: (state) => {
            return {
                ...state,
                thumbnail: [],
                thumbnailName: [],
            };
        },
    },
});

export const {
    setImages,
    setThumbnail,
    setUpdateImgDetails,
    deleteImage,
    deleteThumbnail,
    resetImages,
    resetThumbnail,
} = ImageUploaderSlice.actions;
export default ImageUploaderSlice.reducer;
